import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import './layout.scss'

const Layout = ({ children, header, isSignedIn, connectAction }) => {

    return (
        <div className='app'>
            <Header header={header} isSignedIn={isSignedIn} connectAction={connectAction} />
            {children}
            <Footer />
        </div>
    )
}

export default Layout